import { IonContent, IonPage, IonRow } from '@ionic/react';
import { useEffect, useState } from 'react';

import ContentSpinner from '../../components/loading/ContentSpinner';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { BlogPostsAction } from '../../redux/actions/Blog';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Posts from './Blog/Posts';

interface Props {
  posts: []
}

const Tab4: React.FC<Props> = (props) => {
  const dispatch = useAppDispatch();

  const { loading, blogPosts } = useAppSelector(state => state.blogPostsPost);
  const [blog, setBlog] = useState([] as any);
  const [blogData, setBlogData] = useState({ event: null as any, currentPage: 0 });

  useEffect(() => {
    setBlog(props.posts);
  }, [props.posts])

  const postsLoadMore = (e: any) => {
    const currentPage = blogData.currentPage + 1

    setBlogData({ event: e, currentPage: currentPage })

    dispatch(BlogPostsAction(currentPage));
  }

  useEffect(() => {
    if (blogPosts != null && !loading) {
      if (blogData.event?.target != null) {
        blogData.event?.target.complete();

        const items = blog.concat(blogPosts.posts);

        blogData.event.target.disabled = (items.length == blogPosts.postsTotal);

        setBlog(items);
      }
    }
  }, [loading])

  return <IonPage className="tab-content">
    <Toolbar title="وبلاگ" />

    <LayoutGap />

    <IonContent className="main-content">
      <ContentSpinner loadData={postsLoadMore}>
        <IonRow>
          <Posts items={blog} />
        </IonRow>
      </ContentSpinner>
    </IonContent>
  </IonPage>
}

export default Tab4;
